"use client";

import { motion } from "framer-motion";
import { Table } from "@heroui/react";
import { RATE_LIMIT } from "@/lib/constants";
import { BreachesSection } from "./breaches-section";
import { BREACHES_PRICING_ROWS } from "./breaches-data";

export function BreachesPricing() {
  return (
    <BreachesSection>
      <section className="heroui pb-40">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mb-8 text-center"
        >
          <h2 className="mb-3 text-2xl font-semibold tracking-tight sm:text-3xl">
            Simple, credit-based pricing
          </h2>
          <p className="mx-auto max-w-xl text-sm text-text-tertiary sm:text-base">
            Password checks cost one credit per request. GitHub leaks and exposed API keys cost
            one credit per leak found. Cached repeat requests cost nothing.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="overflow-x-auto hide-scrollbar"
        >
          <Table className="w-max min-w-full md:w-full">
            <Table.Content aria-label="Breaches pricing" className="w-full min-w-full md:table-fixed">
              <Table.Header className="**:[th]:text-text-secondary **:[[role=columnheader]]:text-text-secondary">
                <Table.Column isRowHeader className="whitespace-nowrap md:w-[20%]">Data field</Table.Column>
                <Table.Column className="whitespace-nowrap md:w-[44%]">Details</Table.Column>
                <Table.Column className="whitespace-nowrap md:w-[18%]">Credits</Table.Column>
                <Table.Column className="whitespace-nowrap md:w-[18%]">Rate limit</Table.Column>
              </Table.Header>
              <Table.Body>
                {BREACHES_PRICING_ROWS.map((row, i) => (
                  <Table.Row key={i} id={i}>
                    <Table.Cell className="whitespace-nowrap md:whitespace-normal md:wrap-break-word md:align-top font-medium text-text-primary">{row.field}</Table.Cell>
                    <Table.Cell className="whitespace-nowrap md:whitespace-normal md:wrap-break-word md:align-top text-text-tertiary">{row.details}</Table.Cell>
                    <Table.Cell className="whitespace-nowrap md:align-top">
                      <span className="tabular-nums text-text-secondary">{row.credits}</span>
                    </Table.Cell>
                    <Table.Cell className="whitespace-nowrap md:align-top">
                      <span className="tabular-nums text-text-secondary">{RATE_LIMIT}</span>
                    </Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table.Content>
          </Table>
        </motion.div>
      </section>
    </BreachesSection>
  );
}
